<style>
#watermeterCard .v--modal-box.v--modal {
  min-height: 500px !important;
  min-width: 680px !important;
}
#watermeterCard #attr__wrapper .layout:not(#geometry-panel) {
  margin-top: 20px;
}
#watermeterCard .v-tabs__div:not(:last-child) {
  padding-right: 10px;
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#watermeterCard .v-select__selection {
  font-size: 12px !important;
}
#watermeterCard .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
.prw-card__watermeters {
  margin-top: 20px;
}
</style>

<template>
  <Modal
    modalName="watermeterCard"
    :title="`KARTA WODOMIERZA O ID ${oid}`"
    :buttons="['']"
    :module="module"
    @opened="loadAttachments(), sendId()"
  >
    <div style="height:100%">
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
        style="height:100%"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card
            flat
            id="attr__wrapper"
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.billing_id"
                  label="Identyfikator w systemie billingowym"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.parent_partition"
                  label="Numer punktu rozbioru wody"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.idwodomierz"
                  label="ID wodomierza"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.nrwodomierz"
                  label="Numer wodomierza"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.nrkartotekiwodomierz"
                  label="Numer kartoteki wodomierza"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.status"
                  label="Status"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.dataodczyt"
                  label="Data odczytu"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.odczyt"
                  label="Odczyt"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.grupa"
                  label="Grupa"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.wlasciciel"
                  label="Właściciel"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.idobiektu"
                  label="ID obiektu"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.akronimobiekt"
                  label="Akronim obiektu"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.miejscowosc"
                  label="Miejscowość"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.ulica"
                  label="Ulica"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.nrdomu"
                  label="Numer domu"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.nrlokalu"
                  label="Numer lokalu"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.wlasnoscprzylacza"
                  label="Własność przyłącza"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.srednicawodomierz"
                  label="Średnica wodomierza"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.datamontazwodomierz"
                  label="Data montażu wodomierza"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.datalegalnosciwodomierz"
                  label="Upływ cech legalizacji"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.wlasciciel"
                  label="Właściciel"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="watermeterData.grupa"
                  label="Grupa"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-subheader>Atrybuty użytkownika</v-subheader>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <template v-for="(val, key, index) in customAttributes">
                <v-flex xs5 :key="index">

                  <v-text-field
                    v-model="Object.values(customAttributes)[index]"
                    :label="key"
                    readonly
                  ></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab>HISTORIA</v-tab>
        <v-tab-item>
          <v-card
            flat
            style="height:100%"
          >
            <SingleObjectHistoryTable
              :featureID="oid"
              :objectTable="objectTable"
            />
          </v-card>
        </v-tab-item>

        <v-tab v-if="featureEvents != undefined && featureEvents.hasOwnProperty('events')">ZDARZENIA ({{featureEvents.events_count}})</v-tab>
        <v-tab v-else>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <Events
              style="margin-top: 15px"
              :featureEvents="featureEvents"
              :objectType="objectType"
              :id="oid"
            />
          </v-card>
        </v-tab-item>

        <v-tab>ZAŁĄCZNIKI ({{attachmentsArr.hasOwnProperty('data') ? attachmentsArr.data.length : '0'}})</v-tab>
        <v-tab-item>
          <v-layout row>
            <!-- <v-flex
                xs12
                v-if="$can('read', 'partitions_attachments') || $can('edit', 'partitions_attachments')"
              > -->
            <v-flex xs12>
              <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
              <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{index.id}} - {{index.filename}}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
                    >cloud_download</v-icon>
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'inspections_attachments')"
                    >delete</v-icon>
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                ref="watermeterCardAttach"
                @attachmentAdded="loadAttachments()"
                @attachmentDeleted="loadAttachments()"
                @confDialogOpened="triggerDialogAttach"
                @fileAdded="updateList"
                @fileRemoved="updateListRemove"
                :id_="oid"
                :objectType="objectType"
                :objectTable="objectTable"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
          </v-layout>
          <v-layout
            row
            wrap
            style="height: 90%"
          >
            <v-flex xs12>
              <DatabaseAttachments
                :objectIdCard="oid"
                :objectTableCard="objectTable"
                :objectTypeCard="objectType"
                @attachmentAdded="loadAttachments"
              />
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>

    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import DatabaseAttachments from "../../table/attachments/DatabaseAttachments";
import Events from "../../../shared/Events";
import Modal from "../../../shared/Modal";
import SingleObjectHistoryTable from "../../table/history/SingleObjectHistoryTable.vue"

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal,
    SingleObjectHistoryTable
  },
  data: vm => ({
    attachmentsArr: [],
    attachmentsNumber: 0,
    customAttributes: {},
    dateMenu: false,
    editing: false,
    eventsNumber: 0,
    feature: undefined,
    inspectionTypeDict: [],
    isDrawing: false,
    module: 'watermeters',
    objectType: "watermeters",
    objectTable: "watermeters",
    oid: undefined,
    watermeterData: {},
    watermeterDataCopy: {},
    statuses: [],
    watermeters: []
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.watermeterCardAttach.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    deleteAttachment(attachmentId) {
      this.$refs.watermeterCardAttach.deleteAttachment(attachmentId);
    },
    loadAttachments() {
      let payload = {
        object_type: this.objectType,
        layer: this.objectTable,
        oid: this.oid
      };
      this.$store
        .dispatch("getAttachmentsForObject", payload)
        .then(success => {
          if(success) {
            this.attachmentsArr = this.$store.getters.getObjectAttachments;
          }
        });
    },
    loadData(data) {
      this.oid = data[0].id;
      this.watermeterData = data[0].properties;

      if (this.watermeterData.hasOwnProperty('wlasciciel')) {
        if (this.watermeterData.wlasciciel == 'Z') {
          this.$set(this.watermeterData, 'wlasciciel', 'Zakład');
        } else {
          this.$set(this.watermeterData, 'wlasciciel', 'Klient');
        }
      }
      this.feature = data[0];
      
      for (let [key, val] of Object.entries(this.watermeterData)) {
        if (key.startsWith('custom_')) {
          let splittedKey = key.split('custom_');
          if (!val) {
            val = 'Brak danych'
          }
          this.$set(this.customAttributes, splittedKey[splittedKey.length - 1], val);
        }
      }
    },
    sendId() {
      this.$root.$emit("sendId", this.oid);
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      this.attachmentsNumber = this.$refs.watermeterCardAttach.$refs.attachmentDropzone.getQueuedFiles().length + 1;
    },
    updateListRemove() {
      this.attachmentsNumber = this.$refs.watermeterCardAttach.$refs.attachmentDropzone.getQueuedFiles().length;
    },
    zoomToGeom() {
      const layerInstance = this.layersInstance['terminals'];
      if(!layerInstance.getVisible()) {
        this.$root.$emit(
          "showSnackbar",
          "orange",
          "Włącz widoczność warstwy przyłączy"
        );
        return;
      }
      this.$root.$emit("highlightFeature", this.feature);
      this.$root.$emit("zoomToFeature", this.feature, {
        srid: this.srid
      });
    }
  },
  mounted() {
    this.$root.$on("loadWatermeterCard", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/watermeters/modals/WatermeterCard.vue